<template>
  <div class="search">
    <input
      type="text"
      class="search-field"
      :placeholder="$t('home.search_name')"
      v-model="string"
      @keyup="search"
    />
    <v-icon :size="35" color="#ca00ff" class="search-icon">mdi-magnify</v-icon>
    <a href="#" class="search-reset" @click.prevent="reset">
      <v-icon :size="35" color="#ca00ff" v-if="string.length">mdi-close</v-icon>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      string: ''
    }
  },
  mounted() {
    this.string = this.$store.getters['graduates/getSearchString']
  },
  methods: {
    search() {
      this.$store.dispatch('graduates/search', this.string)
    },
    reset() {
      this.string = ''
      this.$store.dispatch('graduates/search', this.string)
      this.$store.dispatch('graduates/resetLimit')
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.search {
  position: relative;
}

.search-field {
  padding: 0 10px 0 90px;
  border: solid 2px #000;

  &:focus {
    outline: none;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: 100%;
  }
}

.search-icon {
  position: absolute !important;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 27px !important;
  }
}

.search-reset {
  position: absolute !important;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #000 !important;
  line-height: 0;
  text-decoration: none;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .v-icon {
      font-size: 27px !important;
    }
  }
}
</style>
